import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const AllocationModal = ({
  show,
  onHide,
  lotsToAllocate,
  allocationErrors,
  handleModalFieldEdit,
  handleAllocateAsIs,
  handleAllocateEdited,
  themeColors
}) => {
  const {
    bgCard,
    textTheme,
    borderTheme,
    btnBg,
    btnText,
    tableBg,
    tableText,
    tableBorder,
    tableHeaderBg,
    isdark,
    iscolourDark
  } = themeColors;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
    >
      <Modal.Header
        closeButton
        style={{
          background: bgCard,
          color: textTheme,
          borderBottom: `1px solid ${borderTheme}`
        }}
      >
        <Modal.Title style={{ fontSize: "18px", fontWeight: "700" }}>
          Allocate Roll Quantities
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          background: bgCard,
          color: textTheme
        }}
      >
        <p style={{ fontSize: "14px", color: "#8b95a7" }} className="mb-3">
          Specify the number of Roll Takas and Meters to issue from each selected available lot.
        </p>

        <Table hover bordered responsive className="custom-workspace-table" style={{ fontSize: "13px", background: tableBg, color: tableText, borderColor: tableBorder }}>
          <thead>
            <tr style={{ background: tableHeaderBg }}>
              <th style={{ background: "transparent" }}>Lot No</th>
              <th style={{ background: "transparent" }}>Quality</th>
              <th className="text-center" style={{ background: "transparent" }}>Original Taka</th>
              <th className="text-center" style={{ background: "transparent" }}>Original Meter</th>
              <th style={{ width: "130px", background: "transparent" }} className="text-center">Issue Taka</th>
              <th style={{ width: "130px", background: "transparent" }} className="text-center">Issue Meter</th>
            </tr>
          </thead>
          <tbody>
            {lotsToAllocate.map(lot => (
              <tr key={lot.id} style={{ background: tableBg }}>
                <td className="fw-semibold align-middle" style={{ background: "transparent" }}>{lot.lotNo}</td>
                <td className="align-middle" style={{ background: "transparent" }}>{lot.quality}</td>
                <td className="text-center align-middle" style={{ background: "transparent" }}>{lot.origTaka}</td>
                <td className="text-center align-middle" style={{ background: "transparent" }}>{lot.origMeter}</td>
                <td style={{ background: "transparent" }}>
                  <input
                    type="number"
                    value={lot.editTaka}
                    onChange={(e) => handleModalFieldEdit(lot.id, "editTaka", e.target.value)}
                    style={{
                      width: "100%",
                      padding: "6px 10px",
                      borderRadius: "8px",
                      border: allocationErrors[lot.id]?.editTaka ? "1px solid #ef4444" : `1px solid ${borderTheme}`,
                      textAlign: "center",
                      background: isdark === "light" ? "#fff" : iscolourDark?.Colour9 || "#1e293b",
                      color: isdark === "light" ? "#000" : "#fff"
                    }}
                  />
                  {allocationErrors[lot.id]?.editTaka && (
                    <div className="text-danger mt-1 text-center" style={{ fontSize: "10px" }}>
                      {allocationErrors[lot.id].editTaka}
                    </div>
                  )}
                </td>
                <td style={{ background: "transparent" }}>
                  <input
                    type="number"
                    value={lot.editMeter}
                    onChange={(e) => handleModalFieldEdit(lot.id, "editMeter", e.target.value)}
                    style={{
                      width: "100%",
                      padding: "6px 10px",
                      borderRadius: "8px",
                      border: allocationErrors[lot.id]?.editMeter ? "1px solid #ef4444" : `1px solid ${borderTheme}`,
                      textAlign: "center",
                      background: isdark === "light" ? "#fff" : iscolourDark?.Colour9 || "#1e293b",
                      color: isdark === "light" ? "#000" : "#fff"
                    }}
                  />
                  {allocationErrors[lot.id]?.editMeter && (
                    <div className="text-danger mt-1 text-center" style={{ fontSize: "10px" }}>
                      {allocationErrors[lot.id].editMeter}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer
        style={{
          background: bgCard,
          borderTop: `1px solid ${borderTheme}`
        }}
      >
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          onClick={handleAllocateAsIs}
          style={{
            background: "rgba(100,116,139,0.2)",
            color: textTheme,
            border: "none",
            fontWeight: "600"
          }}
        >
          Allocate Full (As-Is)
        </Button>
        <Button
          onClick={handleAllocateEdited}
          style={{
            background: btnBg,
            color: btnText,
            border: "none",
            fontWeight: "600"
          }}
          disabled={Object.keys(allocationErrors).length > 0}
        >
          Confirm Allocation
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AllocationModal;
